import type { ClickHouseConnectorHosting } from "@p0security/integrations-clickhouse-shared/types";

/** A connector image on Docker Hub, pinned by the digest its tag resolves
 * to. */
export type ConnectorImage = Readonly<{
  /** `sha256:<digest>` */
  digest: string;
  name: string;
  tag: string;
}>;

/** The connector build each cloud deploys: one image for AWS Lambda and one
 * for Cloud Run, built from the same service.
 *
 * Each is a p0-security-perimeter build of the connector, by its
 * `sha-<commit>` tag on Docker Hub and the digest that tag resolves to
 * (`docker buildx imagetools inspect <name>:<tag>`). The service's source has
 * moved to `submodules/connector`, but these pins still name perimeter builds
 * until they're moved to that repo's images. */
export const CONNECTOR_IMAGES: Readonly<
  Record<ClickHouseConnectorHosting["type"], ConnectorImage>
> = {
  aws: {
    digest:
      "sha256:8dc0d40bce76e1eeb69e0f1195c41cec28d6f6896c5e5e5889326704c2789e5a",
    name: "p0security/p0-connector-clickhouse",
    tag: "sha-3e75256",
  },
  gcp: {
    digest:
      "sha256:6447a90aa0c4677cefc2a91fc538641808923cee5678c8ecbd03068c627a2266",
    name: "p0security/p0-connector-clickhouse-gcloud",
    tag: "sha-3e75256",
  },
};
